var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeleteModal',{attrs:{"actions":_vm.getActionsCategory.text},on:{"deleteOrder":_vm.deleteItem,"cancelDel":_vm.cancelHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }